import { ConfigurationValueDto } from '@up/data';

export interface DeliveryPartnersThirdPartyIntegrationEnum {
  justEatCollectionMenu?:ConfigurationValueDto;
  justEatDeliveryMenu?: ConfigurationValueDto;
  justEatVendorName?: ConfigurationValueDto;
  justEatLocationReferenceId?: ConfigurationValueDto;
  justEatUpCoAPIKey?: ConfigurationValueDto;
  justEatAPIKey?: ConfigurationValueDto;


  deliverooBrandName?: ConfigurationValueDto;
  deliverooMenu?: ConfigurationValueDto;
  deliverooAPIKey?: ConfigurationValueDto;
  deliverooAPIToken?: ConfigurationValueDto;
  deliverooLocationReferenceId?: ConfigurationValueDto;

  uberEatsClientId?:ConfigurationValueDto;
  uberEatsClientSecret?:ConfigurationValueDto;
  uberEatsLocationId?:ConfigurationValueDto;
  uberEatsMenu?:ConfigurationValueDto;
}

export interface DeliveryPartnersIntegrationJustEatEnum {
  justEatCollectionMenu?:ConfigurationValueDto;
  justEatDeliveryMenu?: ConfigurationValueDto;
  justEatVendorName?: ConfigurationValueDto;
  justEatLocationReferenceId?: ConfigurationValueDto;
  justEatUpCoAPIKey?: ConfigurationValueDto;
  justEatAPIKey?: ConfigurationValueDto;
}

export interface DeliveryPartnersIntegrationUberEatsEnum {
  uberEatsClientId?:ConfigurationValueDto;
  uberEatsClientSecret?:ConfigurationValueDto;
  uberEatsLocationId?:ConfigurationValueDto;
  uberEatsMenu?:ConfigurationValueDto;
}

export interface DeliveryPartnersIntegrationDeliverooEnum {
  deliverooBrandName?: ConfigurationValueDto;
  deliverooMenu?: ConfigurationValueDto;
  deliverooAPIKey?: ConfigurationValueDto;
  deliverooAPIToken?: ConfigurationValueDto;
  deliverooLocationReferenceId?: ConfigurationValueDto;
}
